var React = require('react');

function BgTriangle2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M296.014 152.073L163.699 380.765L8.57439 0.0050578L296.014 152.073Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M561.731 158.463L163.248 380.755L295.511 152.409L561.731 158.463Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M561.73 158.463L295.698 152.413L8.5741 0.00545268L561.73 158.463Z","fill":"#5915C7","key":2})]);
}

BgTriangle2.defaultProps = {"width":"566","height":"390","viewBox":"0 0 566 390","fill":"none"};

module.exports = BgTriangle2;

BgTriangle2.default = BgTriangle2;
